import React from 'react';

import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { Form, FormGroup, Label, Input, Row, Col, Button } from 'reactstrap';

//Scripts auxiliares:
import {registerAuditProcess} from '../../../tools/scripts/customFetching';

//Estilos base:
let errorLabelStyles = { color: "red", marginLeft: 10, marginBottom: 5, marginTop: 5 };

class PasswordChangeForm extends React.Component {

    constructor() {
        super();

        this.state = {
            wrongPasswordsLabelIsActive: false,
            wrongOldPasswordLabelIsActive: false,
            wrongPasswordSizeLabelIsActive: false
        }
    }

    render() {
        return (
            <Form style={{ marginTop: 25, marginBottom: 0 }}
                onSubmit={(e) => {
                    e.preventDefault();

                    if (e.target.newPassword.value === e.target.verifiedPassword.value) {
                        if (e.target.newPassword.value.length >= 5) {
                            this.changeUserPasswordFromBackend(e);
                        }
                        else { this.setState({ wrongPasswordSizeLabelIsActive: true }); }
                    }
                    else { this.setState({ wrongPasswordsLabelIsActive: true }); }
                }}>
                <FormGroup>
                    <Row>
                        <Col md="5">
                            <Label for="newUserEmailInput" style={{ marginTop: 10 }}>Contraseña anterior</Label>
                        </Col>

                        <Col md="7">
                            <Input type="password" name="oldPassword" id="oldPasswordInput" placeholder="tu contraseña actual" required />
                        </Col>
                    </Row>

                    {this.getWrongOldPasswordLabel()}
                </FormGroup>

                <FormGroup>
                    <Row>
                        <Col md="5">
                            <Label style={{ marginTop: 10 }}>Nueva contraseña</Label>
                        </Col>

                        <Col md="7">
                            <Input type="password" name="newPassword" placeholder="tu nueva contraseña" required />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup>
                    <Row>
                        <Col md="5">
                            <Label style={{ marginTop: 10 }}>Nueva contraseña (x2)</Label>
                        </Col>

                        <Col md="7">
                            <Input type="password" name="verifiedPassword" placeholder="repite la nueva contraseña" required />
                        </Col>
                    </Row>
                </FormGroup>

                {this.getWrongPasswordsLabel()}
                {this.getWrongPasswordSizeLabel()}
                
                <Button className="not-visible-button" id="changePasswordSubmitButton" />
            </Form>
        );
    }

    //Métodos operativos:
    changeUserPasswordFromBackend = (e) => {
        this.setState({ 
            wrongPasswordsLabelIsActive: false, 
            wrongOldPasswordLabelIsActive: false,
            wrongPasswordSizeLabelIsActive: false
        });

        let oldPassword = e.target.oldPassword.value;
        let newTargetPassword = e.target.newPassword.value;

        fetch(process.env.REACT_APP_API_URL + "/users/updatePassword", {
            method: 'PUT',
            headers: { 'Authorization': 'Token ' + this.props.activeUser.authToken, 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'old_password': oldPassword, 'new_password': newTargetPassword, 'close_active_sessions': false })
        })
            .then(serverResponse => {
                switch (serverResponse.status) {
                    case 200:
                        this.fireSuccessProcessAlert();
                        
                        registerAuditProcess(this.props, {
                            "event_type": "PASSWORD_CHANGE",
                            "description": "El usuario <b>actualizó su contraseña</b>"
                        });
                        break;

                    case 401:
                        this.setState({ wrongOldPasswordLabelIsActive: true });
                        break;

                    default:
                        this.fireFailedProcessAlert();
                }
            })
            .catch(error => { console.log(error); this.fireFailedProcessAlert(); })
    }

    //Métodos para renderizado:
    getWrongOldPasswordLabel = () => {
        if (this.state.wrongOldPasswordLabelIsActive) {
            return (
                <p style={{ ...errorLabelStyles }}>
                    Contraseña incorrecta...
                </p>
            );
        }
    }

    getWrongPasswordsLabel = () => {
        if (this.state.wrongPasswordsLabelIsActive) {
            return (
                <p style={{ ...errorLabelStyles }}>
                    Las nuevas contraseñas no coinciden...
                </p>
            );
        }
    }

    getWrongPasswordSizeLabel = ()=>{
        if(this.state.wrongPasswordSizeLabelIsActive){
            return (
                <p style={{ ...errorLabelStyles }}>
                    La contraseña debe tener cinco letras o más...
                </p>
            );
        }
    }

    //Métodos relacionados con sweet alert:
    fireFailedProcessAlert = () => {
        Swal.fire('', 'El cambio de contraseña no pudo completarse correctamente', 'error');
    }

    fireSuccessProcessAlert = () => {
        Swal.fire('', 'Tu contraseña fue <b>actualizada con éxito</b>', 'success');

        if (this.props.modalToggle) this.props.modalToggle();
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser,
        coreBackendHost: state.mainReducer.coreBackendHost,
        enableAuditRegistering: state.mainReducer.enableAuditRegistering
    };
};

export default connect(mapStateToProps)(PasswordChangeForm);